import { useEffect } from "react";
import { B2C_EXTERNAL_URL } from "../config/brand";

/**
 * Legacy /b2c route now redirects to the new dedicated MZN 300 domain.
 * amazonico3000.com/b2c → mzn300.com
 */
export default function B2CRedirect() {
  useEffect(() => {
    window.location.replace(B2C_EXTERNAL_URL);
  }, []);

  return (
    <div data-testid="b2c-redirect" className="min-h-screen bg-black text-white flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <img src="/mzn300-logo.png" alt="MZN 300" className="h-24 mx-auto mb-8" />
        <div className="text-[10px] uppercase tracking-[0.4em] text-[#C9A961] font-bold mb-4">Trasferimento in corso</div>
        <h1 className="editorial-heading text-3xl md:text-4xl leading-tight">
          Lo store <span className="italic text-[#C9A961]">MZN 300</span> ora è su un nuovo dominio.
        </h1>
        <p className="mt-6 text-white/60 text-sm">
          Se non vieni reindirizzato automaticamente, <a href={B2C_EXTERNAL_URL} className="text-[#C9A961] underline">clicca qui</a>.
        </p>
      </div>
    </div>
  );
}
